import Auth from '@nordvpn/teams.core/lib/auth';
import { ForgotPassword } from 'pages/ForgotPassword';
import { Login } from 'pages/Login';
import { Login as LoginOld } from 'pages/LoginOld';
import { OidcCallback } from 'pages/OidcCallback';
import { ResetPassword } from 'pages/ResetPassword';
import { Features } from 'types/features/enums';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { useAreFeaturesLoaded } from 'api/FeatureFlags/queries';
import { LogoutRoute } from './LogoutRoute';
import { jsx as _jsx } from "react/jsx-runtime";
var LoginRouting = function LoginRouting() {
    var areFeaturesLoaded = useAreFeaturesLoaded();
    var isUsersManagementEnabled = useFeatureFlag(Features.UsersManagement);
    if (!areFeaturesLoaded) {
        return null;
    }
    return isUsersManagementEnabled ? /*#__PURE__*/ _jsx(Login, {}) : /*#__PURE__*/ _jsx(LoginOld, {});
};
export var AuthRoutes = [{
        pathname: Auth.constants.LOGIN,
        component: function component() {
            return /*#__PURE__*/ _jsx(LoginRouting, {});
        },
        exact: true
    }, {
        pathname: Auth.constants.LOGOUT,
        component: LogoutRoute
    }, {
        pathname: Auth.constants.FORGOT_PASSWORD_PATH,
        component: function component() {
            return /*#__PURE__*/ _jsx(ForgotPassword, {});
        }
    }, {
        pathname: Auth.constants.RESET_PASSWORD_PATH,
        component: function component() {
            return /*#__PURE__*/ _jsx(ResetPassword, {});
        }
    }, {
        pathname: '/oidc/:tenant/callback',
        component: function component() {
            return /*#__PURE__*/ _jsx(OidcCallback, {});
        },
        exact: true
    }];
